import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/identification__mynumbercard_img_04.svg")